import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const LogoWrapper = styled.div`
  width: 13.4vw;
  ${breakpoint('desktop')`
    flex-shrink: 0;
  `}
`
